<script lang="ts">
  import { onMount, afterUpdate } from "svelte";
  import { gameData, gameData2, gameData3 } from "../utils/gameData";
  import { levels } from "../gameLevels/levels";
  import type {
    Element,
    Collection,
    GameArray,
    GameCollections,
    SymmetryType,
  } from "../utils/types";
  import MShape from "./MShape.svelte";
  import { gameStart, winner } from "../stores/winState";
  import { screenWidth } from "../stores/hover";
  import { gameArray1, gamePad1 } from "../stores/gameStore";
  import WinScreen from "../Screens/WinScreen.svelte";
  import ProgressBar from "../components/ProgressBar.svelte";
  import ManualControls from "./Control/ManualControls.svelte";
  import Passive from "./Elements/Passive.svelte";
  import Background from "./Elements/Background.svelte";
  import LightningBar from "../components/LightningBar.svelte";
  import { SymType } from "../stores/settingsStore";
  import Footer from "./Footer.svelte";
  import Header from "./Header.svelte";
  import BackgroundAnimation from "../components/BackgroundAnimation.svelte";

  export let levelNum = 0;
  const HEIGHT = 10;
  const WIDTH = 6;

  $: gamePadWidth = WIDTH * 50;

  $: gameLeftPos = ($screenWidth - gamePadWidth) / 2;

  $: movements = null;

  $: gamePad = [];

  let gameArray: GameCollections = [];

  //let _levelData = levels[levelNum - 1];
  let _levelData = JSON.parse(JSON.stringify(levels[levelNum - 1]));

  gameArray = [..._levelData.collections];
  $SymType = _levelData.settings.symType;

  //const _levelData = JSON.parse(JSON.stringify(_gameData));

  // $: if (levelNum === 1) {
  // 	const _levelData = JSON.parse(JSON.stringify(gameData));
  // 	gameArray = [..._levelData.collections];
  // 	$SymType = _levelData.settings.symType;
  // } else if (levelNum === 2) {
  // 	const _levelData = JSON.parse(JSON.stringify(gameData2));
  // 	gameArray = [..._levelData.collections];
  // 	$SymType = _levelData.settings.symType;
  // } else if (levelNum === 3) {
  // 	const _levelData = JSON.parse(JSON.stringify(gameData3));
  // 	gameArray = [..._levelData.collections];
  // 	$SymType = _levelData.settings.symType;
  // }

  onMount(() => initGamePad());

  const selectedSahpe = (Array: GameCollections) => {
    let selectedShapeIndex = -1;
    Array.forEach((element, index) => {
      if (element.selected) {
        selectedShapeIndex = index;
        return;
      }
    });
    return selectedShapeIndex;
  };

  const findSelectedSahpe = (Array: GameArray) => {
    let selectedCollection: Collection = null;
    Array.collections.forEach((element, index) => {
      if (element.selected) {
        selectedCollection = element;
        return;
      }
    });
    return selectedCollection;
  };

  const selectClickedCollection = (shapeIndex) => {
    gameArray = gameArray.map((element, index) =>
      index === shapeIndex
        ? { ...element, selected: true }
        : { ...element, selected: false }
    );

    // array.forEach((element, index) => {
    // 	if (index === shapeIndex) {
    // 		element.selected = true;
    // 	} else {
    // 		element.selected = false;
    // 	}
    // });
    // //force rerender !!
    // gameArray = [...array];
  };

  const findShapeIndex = (Array: GameArray, collection: Collection): number => {
    let index = 0;
    for (let element of Array.collections) {
      if (element[0] === collection[0] && element[1] === collection[1]) {
        return index;
      }
      index++;
    }
    return 0;
  };

  const initGamePad = () => {
    for (let row = 0; row < WIDTH; row++) {
      gamePad[row] = [];
    }
    for (let row = 0; row < WIDTH; row++)
      for (let col = 0; col < HEIGHT; col++) {
        gamePad[row][col] = 0;
      }
  };

  const collisionFound = (pair: number[]) => {
    let collision = false;
    gameArray.forEach((collection) => {
      if (!collection.selected) {
        for (let item of collection.items) {
          if (item.xpos === pair[0] && item.ypos === pair[1]) {
            collision = true;
            return;
          }
        }
      }
    });
    return collision;
  };
  //TODO ... merge getCellType and getCellColor into one function
  const getCellType = (pair: number[]) => {
    let type = "BACKGROUND";
    gameArray.forEach((collection) => {
      if (!collection.selected) {
        for (let item of collection.items) {
          if (item.xpos === pair[0] && item.ypos === pair[1]) {
            type = collection.type;
            return type;
          }
        }
      }
    });
    return type;
  };

  const getCellColor = (pair: number[]) => {
    let color = "";
    gameArray.forEach((collection) => {
      if (!collection.selected) {
        for (let item of collection.items) {
          if (item.xpos === pair[0] && item.ypos === pair[1]) {
            color = collection.items[0].color;
            return color;
          }
        }
      }
    });
    return color;
  };

  const updateCellColor = (
    cellXpos: number,
    cellYpos: number,
    color: string
  ) => {
    let collectionNumber = 0;
    let itemNumber = 0;
    gameArray.forEach((collection) => {
      collectionNumber++;
      if (!collection.selected) {
        for (let item of collection.items) {
          itemNumber++;
          if (item.xpos === cellXpos && item.ypos === cellYpos) {
            gameArray[collectionNumber].items[itemNumber].color = color;
            return;
          }
        }
      }
    });
  };

  const moveDown = () => {
    const shapeIndex = selectedSahpe(gameArray);
    let canMove = true;

    if (shapeIndex === -1) {
      alert("pleace chooese");
      return;
    }

    gameArray[shapeIndex].items.forEach((item) => {
      if (
        item.ypos === HEIGHT - 1 &&
        canMove &&
        collisionFound([item.xpos, 0])
      ) {
        canMove = false;
      }
      if (canMove && collisionFound([item.xpos, item.ypos + 1])) {
        canMove = false;
      }
    });

    if (canMove) {
      gameArray[shapeIndex].items.forEach((item) => {
        item.ypos >= HEIGHT - 1 ? (item.ypos = 0) : (item.ypos = item.ypos + 1);
      });

      // looks like svelte need to spread the array to be able to rerender
      gameArray = [...gameArray];
    }
  };

  const moveUp = () => {
    const shapeIndex = selectedSahpe(gameArray);
    let canMove = true;

    if (shapeIndex === -1) {
      alert("pleace chooese");
      return;
    }

    gameArray[shapeIndex].items.forEach((item) => {
      if (
        item.ypos === 0 &&
        canMove &&
        collisionFound([item.xpos, HEIGHT - 1])
      ) {
        canMove = false;
      }

      if (canMove && collisionFound([item.xpos, item.ypos - 1])) {
        canMove = false;
      }
    });

    if (canMove) {
      gameArray[shapeIndex].items.forEach((item) => {
        item.ypos <= 0 ? (item.ypos = HEIGHT - 1) : (item.ypos = item.ypos - 1);
      });

      // looks like svelte need to spread the array to be able to rerender
      gameArray = [...gameArray];
    }
  };

  const moveLeft = () => {
    const shapeIndex = selectedSahpe(gameArray);
    let canMoveLeft = true;

    if (shapeIndex === -1) {
      alert("pleace chooese");
      return;
    }

    gameArray[shapeIndex].items.forEach((item) => {
      if (
        item.xpos === 0 &&
        canMoveLeft &&
        collisionFound([WIDTH - 1, item.ypos])
      ) {
        canMoveLeft = false;
      }

      if (canMoveLeft && collisionFound([item.xpos - 1, item.ypos])) {
        canMoveLeft = false;
      }
    });

    if (canMoveLeft) {
      gameArray[shapeIndex].items.forEach((item) => {
        item.xpos <= 0 ? (item.xpos = WIDTH - 1) : (item.xpos = item.xpos - 1);
      });

      // looks like svelte need to spread the array to be able to rerender
      gameArray = [...gameArray];
    }
  };

  const moveRight = () => {
    const shapeIndex = selectedSahpe(gameArray);
    let canMoveRight = true;

    if (shapeIndex === -1) {
      alert("pleace chooese");
      return;
    }

    gameArray[shapeIndex].items.forEach((item) => {
      if (
        item.xpos === WIDTH - 1 &&
        canMoveRight &&
        collisionFound([0, item.ypos])
      ) {
        canMoveRight = false;
      }

      if (canMoveRight && collisionFound([item.xpos + 1, item.ypos])) {
        canMoveRight = false;
      }
    });

    if (canMoveRight) {
      gameArray[shapeIndex].items.forEach((item) => {
        item.xpos >= WIDTH - 1 ? (item.xpos = 0) : (item.xpos = item.xpos + 1);
      });

      // looks like svelte need to spread the array to be able to rerender
      gameArray = [...gameArray];
    }
  };

  const isItemSymemtrical = (array: GameCollections, element: Element) => {
    let symmetry = false;
    for (let collection of array) {
      if (collection.type !== "PASSIVE") {
        for (let item of collection.items) {
          if ($SymType === "Horizontal") {
            if (
              //item.color !== '#454545' &&
              item.xpos === element.xpos &&
              item.ypos === HEIGHT - 1 - element.ypos &&
              item.color === element.color
            ) {
              symmetry = true;
              break;
            } else {
              symmetry = false;
            }
          } else {
            if (
              //item.color !== '#454545' &&
              item.ypos === element.ypos &&
              item.xpos === WIDTH - 1 - element.xpos &&
              item.color === element.color
            ) {
              symmetry = true;
              break;
            } else {
              symmetry = false;
            }
          }
        }
        if (symmetry) break;
      }
    }
    //console.log('this is symmetry', symmetry);

    return symmetry;
  };

  let numberOfSymetricalElements = () => {
    let counter = 0;
    for (let collection of gameArray) {
      for (let element of collection.items) {
        if (isItemSymemtrical(gameArray, element)) {
          counter++;
          //console.log('found symettry');
        }
      }
    }
    return counter;
  };

  $: SymetricalElements = numberOfSymetricalElements();

  let numberofActiveElements = () => {
    let counter = 0;
    for (let collection of gameArray) {
      if (collection.type === "ACTIVE") {
        for (let element of collection.items) {
          counter++;
        }
      }
    }
    return counter;
  };
  $: activeElements = numberofActiveElements();

  // getter
  const playerDidWin = (array: GameCollections) => {
    //console.log('check');
    let winState = false;
    for (let collection of array) {
      if (collection.type !== "PASSIVE") {
        for (let item of collection.items) {
          winState = isItemSymemtrical(array, item);

          if (!winState) {
            break;
          }
        }
        if (!winState) {
          break;
        }
      }
    }
    if (winState) {
      //console.log('WWWWINNNN!!!');
      $winner = true;
      clearInterval(movements);
    }
    // use _array to compare if all its elements are symetrical or not !
    //console.log(_array);
  };

  const addVariantElement = (xpos: number, ypos: number) => {
    //	console.log('GCT', getCellColor([xpos, ypos]));
    if (
      getCellType([xpos + 1, ypos]) === "VARIANT" &&
      getCellColor([xpos + 1, ypos]) === "#454545"
    ) {
      updateCellColor(xpos + 1, ypos, getCellColor([xpos, ypos]));
      //	console.log('hi there');
    }
    if (
      getCellType([xpos - 1, ypos]) === "VARIANT" &&
      getCellColor([xpos - 1, ypos]) === "#454545"
    ) {
      updateCellColor(xpos - 1, ypos, getCellColor([xpos, ypos]));
    }
    if (
      getCellType([xpos, ypos + 1]) === "VARIANT" &&
      getCellColor([xpos, ypos + 1]) === "#454545"
    ) {
      updateCellColor(xpos, ypos + 1, getCellColor([xpos, ypos + 1]));
    }
    if (
      getCellType([xpos, ypos - 1]) === "VARIANT" &&
      getCellColor([xpos, ypos - 1]) === "#454545"
    ) {
      updateCellColor(xpos, ypos - 1, getCellColor([xpos, ypos - 1]));
    }
  };

  const removeVariantElement = (item: Element) => {
    //initially reset the variant color to its original gray color for now .. TODO.. deal with case where there is another adjacent element
    if (
      getCellType([item.xpos + 1, item.ypos]) === "VARIANT" &&
      item.color !== "#454545"
    ) {
      updateCellColor(item.xpos + 1, item.ypos, "#454545");
    }
    if (
      getCellType([item.xpos - 1, item.ypos]) === "VARIANT" &&
      item.color !== "#454545"
    ) {
      updateCellColor(item.xpos - 1, item.ypos, "#454545");
    }
    if (
      getCellType([item.xpos, item.ypos + 1]) === "VARIANT" &&
      item.color !== "#454545"
    ) {
      updateCellColor(item.xpos, item.ypos + 1, "#454545");
    }
    if (
      getCellType([item.xpos, item.ypos - 1]) === "VARIANT" &&
      item.color !== "#454545"
    ) {
      updateCellColor(item.xpos, item.ypos - 1, "#454545");
    }
  };

  const changeVariantElement = () => {
    let colorIsChanged = false;

    for (let collection of gameArray) {
      if (
        collection.type === "VARIANT" &&
        collection.items[0].color !== "#454545"
      ) {
        //console.log('collection.items[0].color', collection.items[0].color);
        if (
          !collisionFound([
            collection.items[0].xpos + 1,
            collection.items[0].ypos,
          ]) ||
          (getCellType([
            collection.items[0].xpos + 1,
            collection.items[0].ypos,
          ]) === "VARIANT" &&
            (!collisionFound([
              collection.items[0].xpos - 1,
              collection.items[0].ypos,
            ]) ||
              getCellType([
                collection.items[0].xpos - 1,
                collection.items[0].ypos,
              ]) === "VARIANT") &&
            (!collisionFound([
              collection.items[0].xpos,
              collection.items[0].ypos + 1,
            ]) ||
              getCellType([
                collection.items[0].xpos,
                collection.items[0].ypos + 1,
              ]) === "VARIANT") &&
            (!collisionFound([
              collection.items[0].xpos,
              collection.items[0].ypos - 1,
            ]) ||
              getCellType([
                collection.items[0].xpos,
                collection.items[0].ypos - 1,
              ]) === "VARIANT"))
        ) {
          collection.items[0].color = "#454545";
        }
      }
      if (
        collection.type === "VARIANT" &&
        collection.items[0].color === "#454545"
      ) {
        const tempElementColor = collection.items[0].color;
        for (let element of collection.items) {
          //find if a specific element exist then return its properties
          // TODO seperate this code into its own function

          for (let collection2 of gameArray) {
            if (collection2.type !== "VARIANT") {
              for (let element2 of collection2.items) {
                if (
                  (element2.xpos === element.xpos + 1 &&
                    element.ypos === element2.ypos) ||
                  (element2.xpos === element.xpos - 1 &&
                    element.ypos === element2.ypos) ||
                  (element2.xpos === element.xpos &&
                    element.ypos === element2.ypos + 1) ||
                  (element2.xpos === element.xpos &&
                    element.ypos === element2.ypos - 1)
                ) {
                  element.color = element2.color;
                  colorIsChanged = true;
                  break;
                }
              }
            }
          }
          if (!colorIsChanged) {
            //element.color = tempElementColor;
          }
        }
      }
    }
  };

  // const addHint = (xpos: number, ypos: number) => {
  // 	console.log(xpos);
  // 	const currentSelectedShape = findSelectedSahpe(gameArray);
  // 	for (let item of currentSelectedShape.items) {
  // 		item.xpos = xpos;
  // 		//item.ypos = item.ypos + currentBlock.ypos;
  // 	}
  // 	gameArray = [...gameArray];
  // };

  //getter ==>
  const getSelectedCollectionIndex = () => {
    let selectedIndex = 0;
    for (let collection of gameArray) {
      if (collection.selected) {
        return selectedIndex;
      }
      selectedIndex++;
    }
  };

  //getter ==>
  const getTotalCollectionsNumber = () => {
    let collectionsNumber = 0;
    for (let collection of gameArray) {
      //if (collection.type === 'ACTIVE') {
      collectionsNumber++;
      //}
    }
    return collectionsNumber;
  };

  //setter
  const selectNextCollection = (index: number) => {
    let counter = 0;
    let found = false;
    for (let i = index + 1; i < getTotalCollectionsNumber(); i++) {
      if (gameArray[i].type === "ACTIVE") {
        found = true;
        counter = index + i;
        selectClickedCollection(i);
        break;
      }
      if (found) break;
    }
    if (counter === 0) {
      selectClickedCollection(0);
    }
  };

  const disableHover = (hoverState: boolean) => {
    hoverState = false;
  };

  const handleMouseDown = (index: number) => {
    selectClickedCollection(index);
  };
  const handleSelectNextCollection = () => {
    const shapeIndex = selectedSahpe(gameArray);
    selectNextCollection(shapeIndex);
  };

  const handleMouseOver = (
    index1: number,
    index2: number,
    x: number,
    y: number
  ) => {
    if (index1 > x) {
      moveRight();
    } else if (index1 < x) {
      moveLeft();
    } else if (index2 > y) {
      moveDown();
    } else if (index2 < y) {
      moveUp();
    }
    //numberOfSymetricalElements();
  };

  // initial State
  //onMount(() => {gamePad1.initGamePad();gameArray1.initGameArray()});
</script>

<svelte:body
  on:mouseup={() => {
    SymetricalElements = numberOfSymetricalElements();
    activeElements = numberofActiveElements();
  }}
/>
<BackgroundAnimation />
<div id="base">
  <Header {SymetricalElements} {activeElements} />
  <!-- <ProgressBar {SymetricalElements} {activeElements} />
	<ProgressBar {SymetricalElements} {activeElements} /> -->

  <Footer />

  {#if $winner}
    <WinScreen {levelNum} />
  {/if}
  <div class="elements-container">
    {#each gamePad as row, index1}
      {#each row as item, index2}
        <Background
          {item}
          x={index1}
          y={index2}
          color="grey"
          renderBorder={true}
          onmouseout={disableHover}
          onmouseover={handleMouseOver}
          winState={() => {
            /* winState could be a global function derived from store to avoid drilling */
            playerDidWin(gameArray);
            addVariantElement(index1, index2);
            removeVariantElement(item);
          }}
        />
      {/each}
    {/each}
    {#each gameArray as collection, index}
      <MShape
        {collection}
        {gameArray}
        onmouseout={disableHover}
        onmouseover={handleMouseOver}
        mousedown={handleMouseDown}
        {isItemSymemtrical}
        {index}
        {changeVariantElement}
        winState={() => {
          /* winState could be a global function derived from store to avoid drilling */
          playerDidWin(gameArray);
        }}
      />
    {/each}
  </div>
  <ManualControls
    {moveDown}
    {moveLeft}
    {moveRight}
    {moveUp}
    {gameArray}
    {handleSelectNextCollection}
    {movements}
    winState={() => {
      /* winState could be a global function derived from store to avoid drilling */
      playerDidWin(gameArray);
    }}
  />
</div>

<style>
  #base {
    display: block;
    margin: 0 auto;
    position: relative;
    width: 300px;
    height: 100vh;
    z-index: 10;
    border-left: 10px solid #c7ddcc;
    border-right: 10px solid #c7ddcc;
    background-color: #c7ddcc;
    box-shadow: 2px 5px 16px 0px #0b325e;
  }

  .elements-container {
    position: relative;
    top: -40px;
  }
</style>
